var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEditPatient = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 25,
  viewBox: "0 0 25 25",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.459 14.412a19.858 19.858 0 0 1 4.2-1.826c.65-.24.72-1.73.255-2.242-.672-.739-1.242-1.606-1.242-3.698A2.958 2.958 0 0 1 9.7 3.413a2.958 2.958 0 0 1 3.026 3.233c0 2.095-.57 2.96-1.241 3.698-.466.513-.395 2.002.254 2.242a19.858 19.858 0 0 1 4.2 1.826"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19 12V2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10"
})), /*#__PURE__*/React.createElement("g", {
  strokeWidth: 1.25
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.5 23 14 24l1-3.5 5.982-5.982a1.768 1.768 0 0 1 2.5 2.5L17.5 23ZM20.232 15.268l2.5 2.5M15 20.5l2.5 2.5"
})))));
export { SvgEditPatient as ReactComponent };
export default __webpack_public_path__ + "assets/images/edit-patient.svg";